var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.734,
    height: 22.734,
    viewBox: "0 0 22.734 22.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_gift",
    "data-name": "vuesax/outline/gift",
    transform: "translate(-236 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift",
    transform: "translate(236 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.078,12.788H4.5c-3.24,0-4.5-1.26-4.5-4.5V.71A.716.716,0,0,1,.71,0H15.867a.716.716,0,0,1,.71.71V8.289C16.577,11.528,15.317,12.788,12.078,12.788ZM1.421,1.421V8.289c0,2.444.635,3.079,3.079,3.079h7.578c2.444,0,3.079-.635,3.079-3.079V1.421Z",
    transform: "translate(3.05 8.762)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.814,6.157H2.6A2.369,2.369,0,0,1,0,3.552V2.6A2.369,2.369,0,0,1,2.6,0H16.814a2.413,2.413,0,0,1,2.6,2.6v.947A2.413,2.413,0,0,1,16.814,6.157ZM2.6,1.421c-.862,0-1.184.322-1.184,1.184v.947c0,.862.322,1.184,1.184,1.184H16.814c.834,0,1.184-.35,1.184-1.184V2.6c0-.834-.35-1.184-1.184-1.184Z",
    transform: "translate(1.658 4.026)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.171,4.258H.942a.716.716,0,0,1-.521-.227A1.605,1.605,0,0,1,.468,1.814L1.813.469A1.624,1.624,0,0,1,4.1.469L6.673,3.045a.713.713,0,0,1,.152.777A.692.692,0,0,1,6.171,4.258ZM1.463,2.837h3L3.092,1.473a.194.194,0,0,0-.275,0L1.472,2.818C1.472,2.828,1.463,2.828,1.463,2.837Z",
    transform: "translate(4.856 1.189)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.938,4.258H.709a.7.7,0,0,1-.654-.436.717.717,0,0,1,.152-.777L2.784.469a1.624,1.624,0,0,1,2.283,0L6.412,1.814a1.6,1.6,0,0,1,.047,2.217A.716.716,0,0,1,5.938,4.258Zm-3.5-1.421h3l-.019-.019L4.072,1.473a.194.194,0,0,0-.275,0Z",
    transform: "translate(10.99 1.189)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.658,7.247A1.659,1.659,0,0,1,0,5.589V.71A.716.716,0,0,1,.71,0H6.432a.716.716,0,0,1,.71.71V5.57A1.653,1.653,0,0,1,4.566,6.943l-.843-.568a.227.227,0,0,0-.265,0l-.89.587A1.61,1.61,0,0,1,1.658,7.247ZM1.421,1.421V5.579a.238.238,0,0,0,.369.2l.89-.587a1.646,1.646,0,0,1,1.828,0l.843.568a.238.238,0,0,0,.369-.2V1.411h-4.3Z",
    transform: "translate(7.758 8.762)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H22.734V22.734H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.447f36a89eb432354b1b3e2212aea10d.svg";
export { ForwardRef as ReactComponent };